import WordService from "@/services/WordService";
import { root } from "@/common/consts";
import RelatedInfo from "@/components/RelatedInfo/RelatedInfo.vue";

export default {
    components: {
        RelatedInfo
    },
    props: {
        slug: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            root,
            nearSynonyms: [],
            title: this.$t("thesaurusNearSynonymsCard", { word: this.slug }),
            error: false
        };
    },
    created() {
        this.refreshComponent();
    },
    watch: {
        $route() {
            this.refreshComponent();
        }
    },
    methods: {
        refreshComponent() {
            WordService.getNearSynonyms(this.slug).then(
                res => {
                    const nearSynonyms = res.nearby_words;
                    if (nearSynonyms.length < 1) {
                        this.error = true;
                    } else if (nearSynonyms.length >= 1) {
                        this.error = false;
                        this.nearSynonyms = nearSynonyms;
                    }

                    this.nearSynonyms = res.nearby_words;
                },
                err => (this.error = true)
            );
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/NearSynonyms/NearSynonyms.js